module.exports = __webpack_public_path__ + "media/images/product_lines/motorcycle/h3-0b5a3f5245ed40cd124b45653b6c62cf.svg";